import { render, staticRenderFns } from "./OfferPieChart.vue?vue&type=template&id=f0d4c982&"
import script from "./OfferPieChart.vue?vue&type=script&lang=js&"
export * from "./OfferPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports